export enum TreatmentBaseVariableId {
  PATIENT_ALLERGIES_AND_MEDICAL_HISTORY = 'patientAllergiesAndMedicalHistory',
  PATIENT_ALLERGIES = 'patientAllergies',
  CURRENT_TREATMENTS = 'currentTreatments',
  CURRENT_DOCTOR_TREATMENTS = 'currentDoctorTreatments',
  CURRENT_EXTERNAL_TREATMENTS = 'currentExternalTreatments',
  DRUG_COUNT = 'drugCount',
}
